import React, { useEffect, useState } from "react";
import { Card, CardContent,Divider, Grid, CircularProgress, Typography,Button } from "@material-ui/core";
import { history } from "../../../../helpers";
import { useSelector } from "react-redux";
import { routePaths } from "../../../config/route-paths";
import { makeStyles } from "@material-ui/core/styles";
import { Skeleton } from "@material-ui/lab";
import EFooterSection from "../../../e_home-page/e_footer-section/e_footer-section";
import PaymentService from "./model/e_service";
import PaymentConfirmationHeader from "../e_payment-confirmation/view/_payment-confirmation-header";
import PostPaymentHandling from "../e_payment-confirmation/view/_post-payment-handling";
import PaymentConfirmationContent from "../e_payment-confirmation/view/_payment-confirmation-content";
import {useMediaQuery} from "react-responsive";
import { useLocation } from "react-router-dom";
import { commonService } from "../../../../services";
import { useTranslation } from "react-i18next";
import {Alert} from "@material-ui/lab";
import { Link } from "react-router-dom";
const useStyles = makeStyles((theme) => ({
  cardHeight: {
    height: "96vh",
    background: theme?.palette?.eWhite?.base + " !important",
  },
  marginLeft: {
    marginLeft: "2% !important",
    [theme.breakpoints.down("md")]: {
      marginLeft: "4% !important",
    },
  },
  containerHeight: {
    height: "auto"
  },
  divHeight: {
    height: "100%"
  },
  heightGrid: {
    height: "80%"
  },
  imgStyle: {
    height: "80%",
    margin: "5% 7% 3% auto",
    [theme.breakpoints.down("md")]: {
      margin: "0% 5% 0% auto",
    },
  },
  dividerColor: {
    backgroundColor: theme.palette.eLight.base,
    marginTop: "15px",
    marginBottom:'0.5rem'
},
  fullWidth: {
    width: "100%"
  },
  imageGrid: {
    display: "flex"
  },
  gridItemContainer:{
    height: "96vh",
  },
  button: {
    "&:hover": {
      backgroundColor: theme.palette.ePrimary.hover,
    },
    borderRadius: 29,
    minWidth: "25%",
    backgroundColor: theme.palette.ePrimary.base,
    color: theme.palette.eWhite.base,
    fontSize:"0.75rem",
    margin:"8% auto"
  },
  footerStyle: {
    bottom: 0,
    alignContent: "center",
    width: "100%",
    [theme.breakpoints.up("xl")]: {
      position: "fixed",
    },
    [theme.breakpoints.down("md")]: {
      marginTop: "2%",
    },
  },
  '@global': {
    html: {
      height: "100%"
    },
    body: {
      height: "100%",
      backgroundColor: theme?.palette?.eFaint?.base
    }
  },
}));

export default function E_BkashPaymentConfirmation(props) {

  let classes = useStyles();
 
  const isTabletOrMobile = useMediaQuery({ query: "(min-width: 550px)" })
  const browserName = useSelector((store) => store?.browserDetect?.browserName);
  let labels = useSelector(
    (store) => store?.labels?.data?.getLabels?.E_AUTH_PAYMENT_CONFIRMATION
  );
  const [postData,setPostData]=useState()
  const [err,setErr] = useState(false)
  const search = props.location.search;
  const paymentID = new URLSearchParams(search).get('paymentID');
  const status = new URLSearchParams(search).get('status');
  const customerNo = useSelector((state)=> state?.meterDetails?.customerNumber)
  const location = useLocation();
  useEffect(()=>{
   history.push({
     pathname: routePaths.PAYMENT,
     state: { paymentID: paymentID, status: status },
 
   });
  },[paymentID])

  useEffect(() => {
    if(location?.state?.paymentID){
      PaymentService.postPayment(location?.state?.paymentID,location?.state?.status,customerNo)
      .then((res) => {
          if(res?.data?.data?.postPaymentProcessing){
          setErr(false)
          setPostData(res?.data?.data?.postPaymentProcessing)
          }
      })
      .catch((err) =>{
          setErr(true)
      })
    }
  }, [location]);
  const [successImg, setSuccessImgPath] = useState();
  const [errorImg, setErrorImgPath] = useState();
  let successImgCode = useSelector(
    (store) =>
      store?.parametersWidgets?.ParameterLookup?.E_PAYMENT_CONFIRMATION_SUCCESS_IMG
  );
  let errorImgCode = useSelector(
    (store) =>
      store?.parametersWidgets?.ParameterLookup?.E_PAYMENT_CONFIRMATION_ERROR_IMG
  );

    useEffect(() => {
      if(successImgCode && errorImgCode){
      commonService.getAssestUrl(successImgCode).then((res) => setSuccessImgPath(res));
      commonService.getAssestUrl(errorImgCode).then((res) => setErrorImgPath(res));
    }}, [successImgCode, errorImgCode]);
  
 

  const SUCCESS ="SUCCESS"
  const {t:payLabel , ready : LabelReady} = useTranslation("label-E_NESCO_PAYMENT")

  const handleBeforeUnload=(e)=>{
    localStorage.setItem("paymentConfirmation","true")
    // e.preventDefault()
    // e.returnValue = '';
  }
  useEffect(()=>{ 
    if(localStorage.getItem("paymentConfirmation") === 'true'){
      localStorage.removeItem("paymentConfirmation")
      history.push(routePaths.LOGIN)
    }
      window.addEventListener("beforeunload", handleBeforeUnload,{capture:true});
      return () => window.removeEventListener("beforeunload", handleBeforeUnload,{capture:true})
},[])

  const [finishStatus, setfinishStatus] = useState(false);
  const onBackButtonEvent = (e) => {
      e.preventDefault();
      if (!finishStatus) {
          // if (window.confirm(payLabel("E_PAYMENT_CONFIRM_CASE"))) {
              setfinishStatus(true)
             history.push(routePaths.QUICK_PAY);
          // } else {
          //     window.history.pushState(null, null, window.location.pathname);
          //     setfinishStatus(false)
          // }
      }
  }
    useEffect(() => {
      window.history.pushState(null, null, window.location.pathname);
      window.addEventListener('popstate', onBackButtonEvent);
      return () => { window.removeEventListener('popstate', onBackButtonEvent); };
    }, []);
    const {t:content, ready: contentReady} = useTranslation("content-E_NESCO_PAYMENT_CONTENT");
  return (
    <>
          <>
                <Card 
                  className={classes.cardHeight}
                  style={{overflowY: browserName === "firefox" ? "auto" : "overlay"}}
                >
                  <CardContent>
                {postData ? (
                   <>
                    {isTabletOrMobile ? (
                            <Grid container
                            className={classes.containerHeight}
                            >
                                <>
                                    <PaymentConfirmationHeader
                                    postData={postData}
                                    />
                                    <Grid xs={12}> <Divider className={classes.dividerColor} /></Grid>
                                    <Grid xs={12}>
                                    <Alert severity="info">{LabelReady ? (<>{payLabel("E_PAYMENT_NOTE_CASE")}</>) : (<Skeleton/>)}</Alert></Grid>
                                    <Grid container className={classes.heightGrid}
                                    direction="row"
                                    >
                                    <Grid item sm={7} xs={12}>
                                        <PaymentConfirmationContent
                                       postData={postData}
                                        />
                                        <br />
                                        <div className={classes.marginLeft}>
                                        {" "}
                                        <PostPaymentHandling
                                           postData={postData}
                                        />
                                        </div>
                                    </Grid>
                                    <Grid item className={classes.imageGrid} sm={5} xs={12}>
                                    <img
                                    src={
                                        postData?.status === SUCCESS
                                        ? successImg?.assetPath
                                        : errorImg?.assetPath
                                    }
                                    className={classes.imgStyle}
                                    alt={
                                        postData?.status === SUCCESS
                                        ? labels?.E_AUTH_PAYMENT_CONFIRMATION_SUCCESS_FALLBACK_TEXT
                                        : labels?.E_AUTH_PAYMENT_CONFIRMATION_ERROR_FALLBACK_TEXT
                                    }
                                    ></img>
                                    </Grid>
                                    </Grid>
                                   </>
                                   <Grid container direction="row">
                                    <Grid item xs={12}>
                                    {contentReady && (<>
                                      <Typography 
                                          fontWeight="bold" 
                                          align="left"
                                          variant="subtitle1" 
                                          dangerouslySetInnerHTML={{
                                          __html: content("E_PAYMENT_FOOTER_CONTENT").answer
                                          }}></Typography></>)}
                                    </Grid>
                                  </Grid>
                            </Grid>
                        ) :
                            (
                            <Grid container 
                                direction="column"
                            >
                                <div className={classes.divHeight}
                                >
                                {labels ? (
                                    <>
                                    <PaymentConfirmationHeader
                                      postData={postData}
                                    />
                                    <Grid xs={12}> <Divider className={classes.dividerColor} />
                                    <Alert severity="info">{LabelReady ? (<>{payLabel("E_PAYMENT_NOTE_CASE")}</>) : (<Skeleton/>)}</Alert></Grid>
                                    <Grid container>
                                        <Grid container
                                        justify="center">
                                        <img
                                            src={
                                                postData?.status === SUCCESS
                                                ? successImg?.assetPath
                                                : errorImg?.assetPath
                                            }
                                            className={classes.imgStyle}
                                            alt={
                                                postData?.status === SUCCESS
                                                ? labels?.E_AUTH_PAYMENT_CONFIRMATION_SUCCESS_FALLBACK_TEXT
                                                : labels?.E_AUTH_PAYMENT_CONFIRMATION_ERROR_FALLBACK_TEXT
                                            }
                                            ></img>
                                        </Grid>
                                        <Grid item
                                        className={classes.fullWidth}
                                        xs={12}>
                                        <PaymentConfirmationContent
                                           postData={postData}
                                        />
                                        <br />
                                        {" "}
                                        <PostPaymentHandling
                                           postData={postData}
                                        />
                                        </Grid>
                                        <Grid container direction="row">
                                    <Grid item xs={12}>
                                    {contentReady && (<>
                                      <Typography 
                                          fontWeight="bold" 
                                          align="left"
                                          variant="subtitle1" 
                                          dangerouslySetInnerHTML={{
                                          __html: content("E_PAYMENT_FOOTER_CONTENT").answer
                                          }}></Typography></>)}
                                    </Grid>
                                  </Grid>
                                    </Grid>
                                    </>
                                ) : (
                                  <>
                                  <Grid container justify="center" alignItems="center">
                                    <Grid item justify="center" alignItems="center"><CircularProgress></CircularProgress></Grid>
                                  </Grid>
                                   <Grid container justify="center" alignItems="center">
                                   <Grid item justify="center" alignItems="center"><Typography variant="body1">{LabelReady ? (<>{payLabel("E_PAYMENT_NOTE_CASE")}</>) : (<Skeleton/>)}</Typography></Grid>
                                 </Grid></>
                                )}
                                </div>
                            </Grid>
                            )
                        }
                   </>
                    ) : (
                      <>
                      <Grid container justify="center" alignItems="center">
                        <Grid item justify="center" alignItems="center"><CircularProgress></CircularProgress></Grid>
                      </Grid>
                       <Grid container justify="center" alignItems="center">
                       <Grid item justify="center" alignItems="center"><Typography variant="body1">{LabelReady ? (<>{payLabel("E_PAYMENT_WAIT")}</>) : (<Skeleton/>)}</Typography></Grid>
                     </Grid></>
                    )}
                  </CardContent>
                </Card>
                <div className={classes.footerStyle}>
                  <EFooterSection />
                  </div>
          </>
    </>
  );
}